var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog--content dialog--extended-width dialog--extended-extra-large-width u-extra-medium-padding--bottom",
        },
        [
          _c("h4", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(_vm._s(_vm.$t("mixingplant.search.title"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-margin-x" }, [
            _c("div", { staticClass: "cell small-auto medium-5" }, [
              _c("div", { staticClass: "grid-x grid-margin-x" }, [
                _c("div", { staticClass: "cell small-auto medium-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "mp_zipcode" } }, [
                      _vm._v("PLZ"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchZipcode,
                          expression: "searchZipcode",
                        },
                      ],
                      staticClass: "form-control form-control--small",
                      attrs: {
                        type: "number",
                        name: "mp_zipcode",
                        id: "mp_zipcode",
                      },
                      domProps: { value: _vm.searchZipcode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchZipcode = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell small-auto medium-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "mp_zipcode" } }, [
                      _vm._v("Umkreis"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchRadius,
                          expression: "searchRadius",
                        },
                      ],
                      staticClass: "form-control form-control--small",
                      attrs: {
                        type: "number",
                        name: "mp_radius",
                        id: "mp_radius",
                      },
                      domProps: { value: _vm.searchRadius },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchRadius = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell small-auto medium-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "invisible" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.searchMixingplants()
                          },
                        },
                      },
                      [_vm._v("Suche")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell medium-12" },
                  [
                    _vm.hasError === true
                      ? _c("div", { staticClass: "callout alert small" }, [
                          _vm._v(_vm._s(_vm.errorMessage)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-page-loading", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLoading,
                          expression: "isLoading",
                        },
                      ],
                    }),
                    _vm._v(" "),
                    !_vm.isLoading
                      ? _c(
                          "ul",
                          { staticClass: "mixingplants-list" },
                          _vm._l(_vm.mixingplants, function (item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass:
                                  "u-extra-small-margin--bottom form-group form-group--check",
                              },
                              [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedMixingplants,
                                        expression: "selectedMixingplants",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "mixingplants[]",
                                    },
                                    domProps: {
                                      value: item.id,
                                      checked: Array.isArray(
                                        _vm.selectedMixingplants
                                      )
                                        ? _vm._i(
                                            _vm.selectedMixingplants,
                                            item.id
                                          ) > -1
                                        : _vm.selectedMixingplants,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.selectedMixingplants,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = item.id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedMixingplants =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedMixingplants = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedMixingplants = $$c
                                          }
                                        },
                                        function ($event) {
                                          return _vm.handleMixingplantCheck(
                                            item.id
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("i"),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "c-ranking",
                                    class: _vm.rankingClass(item.ranking),
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(item.name) +
                                      "\n                  "
                                  ),
                                  _c("strong", [
                                    _c("em", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm._f("convertDistance")(
                                              item.distance
                                            )
                                          ) +
                                          " KM)"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell small-auto medium-7" }, [
              _c("div", { staticClass: "mixingplants-map" }, [
                _c("div", { staticClass: "leaflet-map leaflet-map--map" }, [
                  _c("div", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { id: "mp-leaflet-map-" + _vm._uid },
                  }),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-margin-x" }, [
            _c("div", { staticClass: "cell auto" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addMixingplantsToRoute.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mixingplant.search.add")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog.apply(null, arguments)
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }